import { type FC } from 'react';
import { Button } from 'react-bootstrap';
import { expandChangesButton } from '../styles';

interface Props {
	onClick: () => void;
}

const ExpandChangesButton: FC<Props> = (props) => {
	const { onClick } = props;

	return (
		<Button variant="link" onClick={onClick} className={expandChangesButton}>
			Expand changes
		</Button>
	);
};

export default ExpandChangesButton;
